import {
  SET_BUY_PACKAGE_MODAL_DATA,
  SET_BUY_PACKAGE_LOADING,
  SET_BUY_PACKAGE_STATUS,
  SET_BUY_PACKAGE_MESSAGE,
  SET_BUY_PACKAGE_AUTO_PROLONG,
  CONFIRM_BUY_PACKAGE,
  RESET_BUY_PACKAGE,
  SET_BUY_PACKAGE_HELD_PAYMENT,
  SET_BUY_PACKAGE_CONFIRMATION_TOKEN,
} from '../../actions/buyPackage';
import { TActions } from '../../types/actions';

import { IBuyPackage, EBuyPackageStatus } from '../types';
import { defaultState } from './defaultState';

export const buyPackage = (state: IBuyPackage = defaultState, action: TActions): IBuyPackage => {
  switch (action.type) {
    case SET_BUY_PACKAGE_MODAL_DATA: {
      return {
        ...state,
        isModalShow: true,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    }

    case SET_BUY_PACKAGE_LOADING:
      return { ...state, isLoading: action.payload.isLoading };

    case SET_BUY_PACKAGE_STATUS:
      return { ...state, status: action.payload.status };

    case SET_BUY_PACKAGE_MESSAGE:
      return { ...state, message: action.payload.message };

    case SET_BUY_PACKAGE_AUTO_PROLONG:
      return {
        ...state,
        data: {
          ...state.data,
          autoProlong: action.payload.autoProlong,
        },
      };

    case SET_BUY_PACKAGE_HELD_PAYMENT:
      return {
        ...state,
        data: {
          ...state.data,
          heldPayment: action.payload,
        },
      };

    case SET_BUY_PACKAGE_CONFIRMATION_TOKEN:
      return {
        ...state,
        data: {
          ...state.data,
          confirmationToken: action.payload.confirmationToken,
        },
      };

    case CONFIRM_BUY_PACKAGE:
      return { ...state, status: EBuyPackageStatus.Confirm };

    case RESET_BUY_PACKAGE:
      return { ...defaultState };

    default:
      return state;
  }
};
